/**
 * Maintenance mode: axios interceptor + lightweight store.
 * On 503 with maintenance:true (or GET /api/maintenance/status enabled),
 * App shows MaintenancePage (except /admin and /admin-login).
 */
import axios from "axios";

const API_URL = process.env.REACT_APP_BACKEND_URL;
const EVENT_NAME = "affidya-maintenance";

let state = {
  enabled: false,
  message: "Affidya è temporaneamente in manutenzione. Riprova tra poco.",
  estimated_end: null,
};

const listeners = new Set();

export function getMaintenanceState() {
  return state;
}

export function subscribeMaintenance(listener) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

function emit(next) {
  state = { ...state, ...next };
  listeners.forEach((fn) => {
    try {
      fn(state);
    } catch (e) {
      console.error("maintenance listener error", e);
    }
  });
  if (typeof window !== "undefined") {
    window.dispatchEvent(new CustomEvent(EVENT_NAME, { detail: state }));
  }
}

export function activateMaintenance(payload = {}) {
  emit({
    enabled: true,
    message:
      payload.message ||
      payload.detail ||
      state.message ||
      "Affidya è temporaneamente in manutenzione. Riprova tra poco.",
    estimated_end:
      payload.estimated_end !== undefined ? payload.estimated_end : state.estimated_end,
  });
}

export function clearMaintenance() {
  emit({
    enabled: false,
    message: "Affidya è temporaneamente in manutenzione. Riprova tra poco.",
    estimated_end: null,
  });
}

export async function fetchMaintenanceStatus() {
  try {
    const res = await axios.get(`${API_URL}/api/maintenance/status`);
    const data = res.data || {};
    if (data.enabled) {
      activateMaintenance(data);
    } else if (state.enabled) {
      clearMaintenance();
    }
    return data;
  } catch (err) {
    console.error("Maintenance status check failed:", err);
    return null;
  }
}

let interceptorInstalled = false;

export function installMaintenanceInterceptor() {
  if (interceptorInstalled) return;
  interceptorInstalled = true;
  axios.interceptors.response.use(
    (response) => response,
    (error) => {
      const status = error.response?.status;
      const data = error.response?.data;
      if (status === 503 && data && data.maintenance === true) {
        activateMaintenance(data);
      }
      return Promise.reject(error);
    }
  );
}

// Install on import so AuthContext / App get coverage immediately
installMaintenanceInterceptor();
